@if (currentForm && currentForm.submitted && (currentForm.form.invalid || currentForm.serverError)) {
  <app-error-summary
    [formErrorsMap]="currentForm.formErrorsMap"
    [serverError]="currentForm.serverError"
    [form]="currentForm.form"
    [showServerErrorAsLink]="false"
    >
  </app-error-summary>
}


<h1 class="govuk-heading-l">Forgot username</h1>
<app-find-account (setCurrentForm)="setCurrentForm($event)" (accountFoundEvent)="onAccountFound($event)"/>
@if (accountUid && securityQuestion) {
  <app-find-username [accountUid]="accountUid" [securityQuestion]="securityQuestion" (setCurrentForm)="setCurrentForm($event)" />
}